import React, { Component } from 'react';
import AdSense from 'react-adsense';
import { recordException, enableSafeAdsByGoogle } from '../../services/googleServices';

/**
 * SafeAdSense
 * Resilient wrapper around react-adsense. Catches ad-blocker script errors,
 * container size errors (availableWidth=0), and uninitialized script crashes.
 */
class SafeAdSense extends Component {
  constructor(props) {
    super(props);
    enableSafeAdsByGoogle();
    this.containerRef = React.createRef();
    this.state = {
      hasError: false,
      adBlocked: false,
      isMounted: process.env.NODE_ENV === 'test',
    };
  }

  static getDerivedStateFromError(error) {
    const msg = (error && (error.message || String(error))) || '';
    if (
      msg.includes('already have ads in them') ||
      msg.includes('TagError') ||
      msg.includes('adsbygoogle.push() error') ||
      msg.includes('availableWidth=0')
    ) {
      // Don't flip to fallback state if it's a layout or duplicate push error
      return null;
    }
    return { hasError: true };
  }

  componentDidCatch(error) {
    const msg = (error && (error.message || String(error))) || '';
    if (
      msg.includes('already have ads in them') ||
      msg.includes('TagError') ||
      msg.includes('adsbygoogle.push() error') ||
      msg.includes('availableWidth=0')
    ) {
      return;
    }
    // Suppress ad-blocker or container width errors from bubbling up and crashing app
    recordException(error, { source: 'SafeAdSense', client: this.props.client }, false);
  }

  componentDidMount() {
    enableSafeAdsByGoogle();
    if (!this.state.isMounted) {
      if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => {
          this.setState({ isMounted: true });
        });
      } else {
        this.setState({ isMounted: true });
      }
    }
  }

  render() {
    const {
      client = process.env.REACT_APP_GADS_ID || 'ca-pub-2835578352930332',
      slot = process.env.REACT_APP_GADS_SLOT || '7806394673',
      style = { display: 'block', width: '100%', minHeight: '90px' },
      format = 'auto',
      responsive = 'true',
      className = '',
    } = this.props;

    if (this.state.hasError || this.state.adBlocked) {
      if (process.env.NODE_ENV === 'development') {
        return (
          <div className={`adsense-fallback text-center py-2 text-muted small border rounded my-2 ${className}`}>
            [AdSense Safeguard Active: Ads suppressed or blocked in development/test]
          </div>
        );
      }
      return null;
    }

    return (
      <div
        ref={this.containerRef}
        className={`adsense-container w-100 ${className}`}
        style={{ minHeight: '90px', width: '100%', minWidth: '200px', overflow: 'hidden' }}
      >
        {this.state.isMounted && (
          <AdSense.Google
            client={client}
            slot={slot}
            style={style}
            format={format}
            responsive={responsive}
          />
        )}
      </div>
    );
  }
}

export default SafeAdSense;

